import React, { useMemo } from "react";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

export interface SchedulesReportFilterOption {
    id: string;
    label: string;
}

interface Props {
    options: SchedulesReportFilterOption[];
    selectedIds: string[];
    onChange: (selectedIds: string[] | undefined) => void;
    name: string;
}

export const OptionsMultiselectFilter: React.FC<Props> = ({
    options,
    selectedIds,
    onChange,
    name,
}) => {
    const multiselectOptions = useMemo<FilterMultiselectOption[]>(
        () =>
            options.map((option) => ({
                value: option.id,
                label: option.label,
                searchableLabel: option.label,
            })),
        [options],
    );

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                maxListHeight={340}
                inDropdown={false}
                options={multiselectOptions}
                value={selectedIds}
                onChange={(values) => {
                    const selected = values.map(String);
                    onChange(selected.length > 0 ? selected : undefined);
                }}
                name={name}
                onBlur={noop}
            />
        </div>
    );
};
